<template>
  <aceHotel :revinate_token="revinate_token" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>
<script>
import aceHotel from '@/components/custom/aceHotel/index'
export default {
  name: 'custom_template_ace_palm_springs',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { aceHotel },
  data(){
    return{
      revinate_token: 'bfaf30dd-1242-42be-9e14-275f0ff9149f'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>